import { FC } from 'react';

import { VisuallyHidden } from '../visually-hidden';

import {
  CaloriesText,
  Header,
  ImageContainer,
  LinkWrapper,
  RewardsChipWrapper,
  TextWrapper,
  Wrapper,
} from './menu-carousel-item.styled';
import { MenuCarouselItemProps } from './types';

const MenuCarouselItem: FC<MenuCarouselItemProps> = ({
  'aria-label': ariaLabel,
  calories: caloriesProps,
  'data-testid': dataTestId,
  header,
  href,
  image,
  imageAlt,
  linkAs,
  onClick,
  rewardsChip: rewardsChipProps,
  variant,
  index,
  itemOffset,
  lastItemSlide,
  className,
}) => {
  let calories = variant === 'rewards' || variant === 'item' ? caloriesProps : null;
  let rewardsChip = variant === 'rewards' ? rewardsChipProps : null;

  // Changing tabIndex of the item for keyboard navigation, setting the hidden items to -1
  const tabIndex = index >= itemOffset && index < lastItemSlide ? 0 : -1;
  return (
    <Wrapper aria-label={ariaLabel} className={className}>
      <LinkWrapper
        onClick={onClick}
        as={linkAs || 'a'}
        {...(linkAs ? { to: href } : { href })}
        data-testid={dataTestId}
        tabIndex={tabIndex}
      >
        <ImageContainer aria-hidden>{image}</ImageContainer>
        <TextWrapper>
          <Header hasCalories={!!calories}>{header}</Header>
          {imageAlt && <VisuallyHidden>{imageAlt}</VisuallyHidden>}
          {calories && <CaloriesText>{calories}</CaloriesText>}
          {rewardsChip && <RewardsChipWrapper>{rewardsChip}</RewardsChipWrapper>}
        </TextWrapper>
      </LinkWrapper>
    </Wrapper>
  );
};

export default MenuCarouselItem;
